import React from 'react';
import { Text, useToast } from '@chakra-ui/react';
import isArray from 'lodash/isArray';

const useToastList = () => {
  const toast = useToast();

  return ({ messages = {}, ...rest }) => {
    console.log(messages);
    if (isArray(messages)) {
      toast({ description: messages.join(", "), isClosable: true, ...rest });
      return;
    } 
    const description = Object.keys(messages).length
      ? Object.keys(messages).map((error, i) => (
          <Text key={i} fontSize="sm" pt={1}>
            {error&&error+': '}{messages[error]}
          </Text>
        ))
      : messages;

    toast({ description, isClosable: true, ...rest });
  };
};

export default useToastList;
